const EXCLUDE_FROM_PHONE = /[^+\d]/g;

export function buildTelHref(phone = ''): string {
  return phone ? `tel:${phone.replace(EXCLUDE_FROM_PHONE, '')}` : '';
}
